import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiBook, FiHeart, FiTarget, FiAward} = FiIcons;

const IntroSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-8">
        <motion.div 
          initial={{opacity: 0, y: 30}} 
          whileInView={{opacity: 1, y: 0}} 
          transition={{duration: 0.6}} 
          viewport={{once: true}}
          className="max-w-4xl mx-auto text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8">
            Digitale Buchhaltung, die dir Überblick, Rechtssicherheit und Zeit verschafft
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed mb-8">
            Viele Selbstständige geraten in Stress, weil Belege, Rechnungen und Fristen an verschiedenen Stellen liegen. 
            Das kostet Zeit, führt zu Unsicherheit und kann im schlimmsten Fall teuer werden.
          </p>
          <p className="text-xl text-gray-600 leading-relaxed mb-8">
            Mit einer digitalen Buchhaltung hast du alles an einem Ort – klar strukturiert und jederzeit nachvollziehbar.
          </p>
          <p className="text-xl text-gray-600 leading-relaxed mb-8">
            Du weißt genau:<br />
            • welche Rechnungen offen sind<br />
            • welche Zahlungen eingegangen sind<br />
            • welche Fristen anstehen
          </p>
          <p className="text-xl text-gray-600 leading-relaxed mb-8">
            Du musst dafür kein Buchhaltungswissen mitbringen. <br />
            Ich zeige dir Schritt für Schritt, wie du dein System so aufbaust, dass du dich sicher fühlst und es selbst bedienen kannst.
          </p>
          <p className="text-xl text-gray-600 leading-relaxed mb-8">
            So gewinnst du Ruhe, Struktur und Zeit für das, was dir wichtig ist: dein Business, deine Ideen, dein Leben. <br />
            Und wenn unterwegs Fragen auftauchen, klären wir sie gemeinsam - bis es für dich wirklich rund läuft.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default IntroSection;